import React, { useContext } from 'react';
import { Segment, Header, Button, Divider, Checkbox } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { ThemeContext } from '../../context/ThemeContext'

function ThemeToggle() {
	const { theme, setTheme } = useContext(ThemeContext);
	return (
		<div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
			<Checkbox
				toggle
				checked={theme === 'dark'}
				onChange={(_, data) => setTheme(data.checked ? 'dark' : 'light')}
			/>
			<span className="theme-toggle-label">Sötét mód</span>
		</div>
	);
}

/**
 * Profile component
 */
export default class Profile extends React.Component {

	/**
	 * Logout
	 */
	handleLogout() {
		this.props.logout();
	}

	render() {
		const role = this.props.profile.role;

		return  <Segment basic>
                    <Header as='h3'>
						{ this.props.profile.username }
                    </Header>
					{
						role === "Admin"
						?
						<b>Adminisztrátor</b>
						:
						role === "RSM"
						?
						<b>RSM</b>
						:
						<span>
							<b>Látogatói terület</b>: { this.props.profile.visitorTerritory }<br/>
							<b>Line</b>: { this.props.profile.line || '—' }<br/><br/>
							Ez a profil oldalad. A paneledet <Link to='/panelChanges'>itt tudod</Link> módosítani.
						</span>
					}
					<Divider/>
					<div style={{ marginBottom: '1rem' }}>
						<ThemeToggle />
					</div>
					<Divider/>
					<Button basic onClick={ () => this.handleLogout() } floated='right' color='red'>Kijelentkezés</Button>
                    <Header color='grey' as='h6'>
                        SXT Kft. &copy; 2019 - 2026
					</Header>
				</Segment>
	}
}